<template>
	<div class="warning-window" @mouseenter="enter" @mouseleave="leave">
		<el-row class="warning-window-header thmeBackColor">
			<el-col :span="12" class="textL">
				<div class="textL">
					<img @click="changeTipVoiceStatus" src="../../../assets/img/tanchuang/tipSound00.png" style="margin: -3px 0px 0px -2px" alt="" class="curpointer" v-if="tipVoiceStatus" >
					<img @click="changeTipVoiceStatus" src="../../../assets/img/tanchuang/tipSound11.png" style="margin: -3px 0px 0px -2px" alt="" class="curpointer" v-else>
					<span style="margin-left: 5px;font-size: 15px">预警提示</span>

				</div>
			</el-col>
			<el-col :span="12" class="textR"><span class="curpointer" @click.stop="closeWarning"><img src="../../../assets/img/tanchuang/guanbi.png" alt=""></span></el-col>
		</el-row>
		<div class="warning-window-content">
			<div class="list-div">
				<ul>
					<li class="lis-row" v-for="item in warnList" :key="item.id">
						<div class="warning-title">
							<p class="textOverOneLine"><a target="_blank" :href="item.url" class="hovertext">{{item.title}}</a></p>
						</div>
						<el-row class="flex-center">
							<el-col :span="12"> {{item.pageTime}}<span class="xing-icon">
							<span><img src="../../../assets/img/earlyWarning/kongxin1.png" alt="" v-if="item.warnDegree === 1" /></span>
							<span><img src="../../../assets/img/earlyWarning/banxin1.png" alt="" v-if="item.warnDegree === 2" /></span>
							<span><img src="../../../assets/img/earlyWarning/manxin1.png" alt="" v-if="item.warnDegree === 3" /></span>
							</span>
							</el-col>

							<el-col :span="12" class="textR col-h" >
								<span class="copy-icon curpointer" @click="copy(item)"><img src="../../../assets/img/tanchuang/fuzhi.png" alt="">复制</span>
							</el-col>
						</el-row>
					</li>
				</ul>
			</div>
		</div>
		<audio v-if="!tipVoiceStatus" src="../../../assets/tip.mp3" autoplay="autoplay"></audio>
		<closed-prop2 ref="closedProp2"></closed-prop2>
	</div>
</template>

<script>
	export default{
		props: {
			warnList: {
				type: Array,
				default: () => []
			}
		},
		data(){
			return{
				tipVoiceStatus: false,
				newList:[
					{id:'1',title:'孙力军落马，公安疫情期间曾任中间曾任中央指导组成员孙力军落马，公安疫情期间曾任中间曾任中央指导组成员',pageTime:'04-15 08:09',warnDegree:1,copy:'公安疫情期间曾任中间曾任中央指导组成员',url:'https://www.toutiao.com/a6833587560690745869/'},
				],
				userInfo:{},
				timer:null
			}
		},
		created() {
			this.initTipVoiceStatus();
			this.userInfo = this.$cookies.get('userInfo');
		},
		mounted() {
			this.leave()
		},
		methods:{
			enter:function(){
				clearTimeout(this.timer)
			},
			leave:function(){
				clearTimeout(this.timer)
				this.timer = setTimeout(() => {
					
					this.$emit('onClose')
					clearTimeout(this.timer)
				}, 15000);
			},
			closeWarning:function(){
				this.$store.commit('closeWarning', true);
			},
			initTipVoiceStatus:function(){
				
				if(this.$cookies.get('tipVoiceStatus') == 0){
					this.tipVoiceStatus = false
				}
				// this.audio = new Audio();
				// this.audio.src = "../../../assets/tip.mp3";
				
				// let playPromise;
				// playPromise = this.audio.play();

				// let status = this.$cookies.get('tipVoiceStatus')
				
			},
			pageIsHidden:function(){
				let hidden
				if (typeof document.hidden !== "undefined") {
					hidden = "hidden";
				} else if (typeof document.mozHidden !== "undefined") {
					hidden = "mozHidden";
				} else if (typeof document.msHidden !== "undefined") {
					hidden = "msHidden";
				} else if (typeof document.webkitHidden !== "undefined") {
					hidden = "webkitHidden";
				}
				return document[hidden]
			},
			changeTipVoiceStatus:function(){
				this.tipVoiceStatus = !this.tipVoiceStatus
				if(this.tipVoiceStatus){
					this.$cookies.set('tipVoiceStatus.'+this.userInfo.usid,1)
				}else {
					this.$cookies.set('tipVoiceStatus.'+this.userInfo.usid,0)
				}

			},
			copy(item) {
				
				let that = this;
				let text = '标题：' + item.title + '\n链接：' + item.url + '\n时间：' + item.pageTime + '\n来源：' + item.websiteName;
				this.$copyText(text).then(
						function(e) {
							that.$refs.closedProp2.show('内容已复制到剪切板！')
							//that.$message.success('内容已复制到剪切板！');
						},
						function(e) {
							that.$refs.closedProp2.show('抱歉，复制失败！')
							//that.$message.error('抱歉，复制失败！');
						}
				);
			},

		}
	}
</script>

<style lang="less">
	.warning-window {
		width: 450px;
		height: 300px;
		background-color: #fff;
		//box-shadow: 0px 4px 8px 0px #d7dde3;
		border-radius: 3px;
		border: solid 1px #d9dbdc;

		.warning-window-header {
			padding: 0px 12px;
			height: 40px;
			line-height: 40px;
			font-family: MicrosoftYaHei;
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 1px;
			color: #ffffff;
		}

		.warning-window-content {
			//background-color: red;
			padding: 5px 18px;
			height: 260px;

			.list-div {
				height: 100%;
				background-color: #fff;

				.lis-row {
					border-bottom: 1px dashed #e4e5e5;
					padding-bottom: 6px;

					&:last-child {
						border-bottom: none
					}
                    .col-h{
						height: 20px;
					}
					&:hover {
						background-color: #fafafa;

						.warning-title {
							// font-family: MicrosoftYaHei-Bold;
							// font-weight: bold;
						}

						.flex-center {
							.copy-icon {
								display: inline-block;
							}
						}


					}

					.warning-title {
						font-family: MicrosoftYaHei;
						font-size: 14px;
						font-weight: normal;
						font-stretch: normal;
						letter-spacing: 0px;
						color: #666666;
						line-height: 34px;
					}

					.flex-center {
						font-family: MicrosoftYaHei;
						font-size: 14px;
						font-weight: normal;
						font-stretch: normal;
						letter-spacing: 0px;
						color: #999999;
						display: flex;
						align-items: center;

						.xing-icon {
							margin-left: 22px;
						}

						.copy-icon {
							margin-right: 18px;
							display: none;
						}
					}
				}

			}
		}
	}
</style>
